import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import * as Actions from 'actions';
import { Row, Col, Collapse } from 'react-bootstrap';
import { fetchOpporunitiesSummary, fetchJobs } from 'api';
import { OpportunityCard } from 'components';
import moment from 'moment';

class PipelineSummary extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetching_opportunities: false,
    }

    this.toggleOpen = this.toggleOpen.bind(this);
    this.allJobsDownloaded = this.allJobsDownloaded.bind(this);
    this.handleClickDownloadMoreJobs = this.handleClickDownloadMoreJobs.bind(this);
  }
  state = {
    summary : undefined,
    open : !localStorage? true : localStorage.getItem('pipeline-summary.open') == 'true',
  }
  options = [
    'primary', 'secondary', 'tertiary',
    'quartenary', 'success', 'warning',
    'info', 'dark', 'danger'
  ];

  toggleOpen() {
    if(localStorage) {
      localStorage.setItem('pipeline-summary.open', this.state.open ? 'false' : 'true');
    }
    this.setState({ open: !this.state.open });
  }
  allJobsDownloaded(milestone_name) {
    const { count, closed } = this.props.summary.find(s => s._id == milestone_name) || { count: 0, closed: 0 };
    const total_jobs = count - closed;
    const downloaded_jobs_count = this.props.jobs.downloaded_jobs.reduce((acc, { job }) => job.milestone == milestone_name ? acc + 1 : acc, 0);
    return downloaded_jobs_count >= total_jobs;
  }
  handleClickDownloadMoreJobs(milestone_name) {
    const { downloaded_jobs } = this.props.jobs;
    const { count, closed } = this.props.summary.find(s => s._id == milestone_name) || { count: 0, closed: 0 };
    const fetched_jobs = downloaded_jobs.filter(({ job }) => job.milestone == milestone_name).length;
    const total_jobs = (count || 0) - (closed || 0);

    if(
      !this.props.jobs.downloading_jobs &&
      !this.state.fetching_opportunities &&
      fetched_jobs <= total_jobs
    ) {
      this.setState({ fetching_opportunities: milestone_name });
      const current_job_numbers = downloaded_jobs
      .filter(({ job }) => job.milestone == milestone_name)
      .map(({ job }) => job.number);

      const current_count = Math.min(...current_job_numbers);
      const fetch_options = {
        filters: [
          {
            type: 'milestone',
            value: milestone_name
          },
          {
            type: 'number',
            value: {
              max: current_count - 1
            }
          }
        ],
        show_closed: false
      };
      fetchJobs(fetch_options)
      .then(res => {
        this.props.recieveNextJobs(res);
      })
      .catch(e => {
        console.log(e);
        this.props.notify({ message: e.message || e });
      })
      .finally(() => this.setState({ fetching_opportunities: false }));
    }
  }
  componentWillMount() {
    this.props.fetchPipeline();
    this.props.fetchJobs({ show_closed: false });
    fetchOpporunitiesSummary().then(this.props.updatePipelineSummary);
  }

  render() {
    const { pipeline, fetching, jobs, summary } = this.props;
    if(fetching) {
      return <div><i className='fa fa-spinner fa-spin fa-2x'></i> Loading Pipeline</div>
    }
    if(!pipeline) {
      return <div></div>
    }

    return (
      <div className='pipeline-summary'>
        <Row>
          <Col xs={12}>
            <h3 className='text-dark'>
              <i className='fa fa-truck' />
              Pipeline
              <span
                onClick={this.toggleOpen}
                style={{cursor: 'pointer'}}
                className='pull-right'
                >
                <i className={`fa fa-chevron-${this.state.open ? 'down' : 'left'}`} />
              </span>
            </h3>
            <div
              style={{ whiteSpace: 'nowrap', overflowY: 'auto', background: 'none' }}
              className='clearfix pipeline-summary-opportunities-container'
              >
              {pipeline && pipeline.stages ? pipeline.stages.map((stage, idx, arr) => {
                const downloaded_jobs = jobs.downloaded_jobs.filter(({ job }) => job.milestone == stage.name);
                const { estimate, price, count } = ((summary || []).find(({ _id }) => _id == stage.name) || { estimate: 0, price: 0, count: 0 });
                const column_style = {
                  whiteSpace: 'nowrap',
                  verticalAlign: 'top',
                  display: 'inline-block',
                  minWidth: `250px`,
                  width: `${100/pipeline.stages.length}%`,
                };

                return (
                  <div
                    key={stage._id}
                    style={column_style}
                    >
                    <div className={`panel-featured panel-featured-${this.options[idx % 8]} mb-none`} style={{ borderRadius : '0px'}}>
                      <div className='panel-heading'><h3 className='panel-title text-center'>{stage.name}</h3></div>
                      <div>
                        <span><i className='fa fa-handshake-o'></i> {count}</span>{' '}
                        <span className='text-success'><i className='fa fa-money'></i> {(estimate || 0).toLocaleString()}</span>
                      </div>
                      <hr className='dotted mt-none mb-sm' />
                      <Collapse
                        in={this.state.open}
                        className='collapse-comp'
                        >
                        <div className='pipeline-summary-column-outer-container'>
                          <ul className='list-unstyled pipeline-summary-column-inner-container'>
                            {downloaded_jobs.map(({ job }) => (
                              <li key={job._id} className='mb-none animated fadeInUp'>
                                <OpportunityCard
                                  job={job}
                                  style={this.options[idx % 8]}
                                  user={this.props.connection.user}
                                />
                              </li>
                            ))}
                          </ul>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                )
              }) : null}
              <div className='pipeline-summary-footer-buttons-container'>
                {pipeline && pipeline.stages && this.state.open ? pipeline.stages.map((stage, idx, arr) => {
                  const column_footer_style = {
                    minWidth: `250px`,
                    width: `${100/pipeline.stages.length}%`,
                  };

                  return (
                    <div
                      className={`pipeline-opportunity-column-footer ${idx == 0  ? 'first' : idx == arr.length - 1 ? 'last' : ''}`}
                      style={column_footer_style}
                      >
                      {jobs.downloading_jobs || this.state.fetching_opportunities == stage.name ? (
                        <span><i className='fa fa-spinner fa-spin fa-2x'></i> Downloading Jobs...</span>
                      ) : this.allJobsDownloaded(stage.name) ? (
                        <span>All Jobs Downloaded.</span>
                      ) : (
                        <a onClick={() => this.handleClickDownloadMoreJobs(stage.name)}>Download More <i className='fa fa-arrow-down'></i></a>
                      )}
                    </div>
                  )
                }) : null}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

const mapStateToProps = ({connection, pipeline, jobs}) => ({...pipeline, jobs, connection});
export default connect(mapStateToProps, Actions)(PipelineSummary);



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-summary.js